<div  class="MainContainer">
    <div class="MainTitleBar">
      <p class="SectionHalfTitle" style="margin-top: 0%;">{{ 'PurchaseContractsTitle' | translate }}</p>
      <div class="SectionHalfTitle SectionHalfTitleRight">
          <button style="padding-left: 10px;margin-right: 10px;" mat-raised-button color="primary" (click)="this.parent.RedirectToURL('dashboard/purchases/contract');"><i class="material-icons">add</i> {{'PurchaseContract' | translate}}</button>
          <button (click)="ExportPurchaseContractsValues();" style="padding-left: 10px;background:#32aa3a;" mat-raised-button color="primary"><i class="material-icons">file_download</i> {{'Export' | translate}}</button>
        </div>
  </div>
  
  <div class="overlay" *ngIf="ShowDeactivateDocumentQuestion || ShowReactivateDocumentQuestion || ShowDeletePCQuestion || showEditPartnerPopUp || showPurchaseContractVisualizer || ShowSuggestionPaymentsContainer || ShowPaymentContainer;" (click)="showEditPartnerPopUp = false; showPurchaseContractVisualizer = false;"></div>
  
  <div class="animated fadeInDown CashCollectionContainer" *ngIf="ShowSuggestionPaymentsContainer" style="left: 16%;width: 83%;">
    <div class="PopUpCloseContainer" (click)="ShowSuggestionPaymentsContainer = false;">
      <i class="material-icons">close</i>
    </div>
  
    <div class="PopUpTitleContainer" style="height: auto;">
      <p>{{ 'DetectedPayments' | translate }}</p>
  
      <div class="PurchaseContractProductsHeadder PurchaseContractProductsRow" style="border: none;width: 95%;margin-left: 2.5%;margin-top: 15px;">
        <div class="PurchaseContractProductsCol" style="width: 5%;">
          {{ 'Document' | translate }}
        </div>
        <div class="PurchaseContractProductsCol" style="width: 15%;">
          {{ 'Supplier' | translate }}
        </div>
        <div class="PurchaseContractProductsCol" style="width: 10%;">
          {{ 'PaymentDate' | translate }}
        </div>
        <div class="PurchaseContractProductsCol" style="width: 10%;">
          {{ 'Value' | translate }} 
        </div>
        <div class="PurchaseContractProductsCol" style="width: 10%;">
          {{ 'PaymentType' | translate }}
        </div>
        <div class="PurchaseContractProductsCol" style="width: 5%;">
            {{ 'Currency' | translate }}
        </div>
        <div class="PurchaseContractProductsCol" style="width: 5%;">
            {{ 'PurchaseContracts.ExchangeRate' | translate }}
          </div>
        <div class="PurchaseContractProductsCol" style="width: 10%;">
          {{ 'PurchaseContracts.DecimalPercision' | translate }}
        </div>
        <div class="PurchaseContractProductsCol" style="width: 20%;">
            {{ 'CollectionExternalID' | translate }}
        </div>
        <div class="PurchaseContractProductsCol" style="width: 10%;">
            {{ 'Actions' | translate }}
        </div>
      </div>
     </div>
  
     <div class="PopUpBody" style="margin-top: 5px;">
  
    <div class="PurchaseContractProductsContainer  top-box">
  
        <div class="PurchaseContractProductsRow TotalRow" *ngIf="loading">
            <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
        </div>
  
        <div *ngIf="!loading">
            <div class="PurchaseContractProductsRow" *ngFor="let c of this.SuggestedPayments; let i=index;" [ngClass]="{'UnAssociatedPayment': c.Status.ID == -1, 'AssociatedPayment': c.Status.ID == 1, 'DupplicateCC': c.IsDuplicate == true }">
                <div class="PurchaseContractProductsCol" style="width: 5%;">
                 <span *ngIf="c.Status.ID == 1;">{{c.DisplayValue}}</span>
                 <span *ngIf="c.Status.ID == -1;">---</span>
                </div>
                <div class="PurchaseContractProductsCol" style="width: 15%;">
                    <span *ngIf="c.Status.ID == 1;">{{c.Supplier.Name}}</span>
                    <span *ngIf="c.Status.ID == -1;">[ {{c.Status.Name}} ]</span>
                </div>
                <div class="PurchaseContractProductsCol" style="width: 10%;">
                  {{c.PaymentDateUI}}
                </div>
                <div class="PurchaseContractProductsCol" style="width: 10%;">
                  {{c.Value}} 
                </div>
                <div class="PurchaseContractProductsCol" style="width: 10%;">
                  {{c.Type.Name}}
                </div>
                <div class="PurchaseContractProductsCol" style="width: 5%;">
                    {{c.Currency.Name}}
                </div>
                <div class="PurchaseContractProductsCol" style="width: 5%;">
                    <span *ngIf="c.Currency.ExchangeRate > 0;">{{c.Currency.ExchangeRate}}</span>
                    <span *ngIf="c.Currency.ExchangeRate == 0;">---</span>
                  </div>
                <div class="PurchaseContractProductsCol" style="width: 10%;">
                    {{c.Currency.DecimalPrecision.ID}}
                </div>
                <div class="PurchaseContractProductsCol" style="width: 20%;">
                    {{c.PaymentExternalID}}
                </div>
                <div class="PurchaseContractProductsCol" style="width: 10%;">
                    <i class="material-icons PurchaseContractProductEdit" (click)="OpenSuggestedPaymentModifier(c); ShowSuggestedPaymentModifier = true;">edit</i>
                    <i class="material-icons PurchaseContractProductEdit" style="color: red;" (click)="ClonePayment(c); ShowDeleteSpendingQuestion = true;">close</i>
                </div>
            </div>
        </div>
  
      
    </div>
    
     </div>
  
     <div class="PopUpCommands" style="height: auto;min-height: 50px;padding-bottom: 15px;">
        <div *ngIf="this.SuggestedPayments != null && this.SuggestedPayments.length > 0 && !loading;">
            <div class="PurchaseContractProductsRow PurchaseContractProductsRowHover TotalRow" *ngFor="let Total of this.PaymentTotals; let i=index;">
                <div class="PurchaseContractProductsCol" style="width: 5%;">
                     
                </div>
                <div class="PurchaseContractProductsCol" style="width: 15%;">
                </div>
                <div class="PurchaseContractProductsCol" style="width: 10%;text-align: left;padding-left: 1%;">
                    {{this.SuggestedPayments.length}} {{'Payments' | translate}}
                </div>
                <div class="PurchaseContractProductsCol totalCol" style="width: 10%;">
                    Total:
                </div>
                <div class="PurchaseContractProductsCol totalCol" style="width: 10%;">
                  <p>{{Total.UITotalQtyPriceVAT.Integer}} <span class="DecimalsSpan">{{Total.UITotalQtyPriceVAT.Decimals}}</span></p>
                </div>
                <div class="PurchaseContractProductsCol totalCol" style="width: 5%;">
                    {{Total.Currency.Name}}
                </div>
                <div class="PurchaseContractProductsCol totalCol" style="width: 5%;">
                    
                </div>
                <div class="PurchaseContractProductsCol totalCol" style="width: 10%;">
                    
                </div>
                <div class="PurchaseContractProductsCol" style="width: 20%;">
                  
                </div>
                <div class="PurchaseContractProductsCol" style="width: 10%;">
                    
                </div>
            </div>
        </div>
    </div>
  </div>
  
  <div class="animated fadeInDown CashCollectionContainer" *ngIf="ShowSuggestedPaymentModifier">
    <div class="PopUpCloseContainer" (click)="ShowSuggestedPaymentModifier = false;">
      <i class="material-icons">close</i>
    </div>
  
    <div class="PopUpTitleContainer">
      <p *ngIf="this.currentPayment.ID > 0;">{{ 'UpdatePayment' | translate }}</p>
      <p *ngIf="!this.currentPayment.ID > 0;">{{ 'NewPayment' | translate }}</p>
     </div>
  
     <div class="PopUpBody" style="margin-top: 20px;">
        
        <div class="currentPaymentRadioGroupContainer">
            <mat-radio-group
            [(ngModel)]="currentPayment.Category">
            <mat-radio-button class="example-radio-button" *ngFor="let c of this.PaymentCategories" [value]="c">
              {{c.Name}}
            </mat-radio-button>
          </mat-radio-group>
        </div>
  
        <div *ngIf="this.currentPayment.Category.ID == 0;">
            <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
                <mat-label>{{ 'AssociatedPurchaseContract' | translate }}*</mat-label>
                <input *ngIf="!this.currentPayment.PurchaseContractID.length > 0;" matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentPayment.DisplayValue" (click)="SearchPurchaseContracts(this.currentPayment.DisplayValue);" (keyup)="SearchPurchaseContracts(this.currentPayment.DisplayValue);">
                <input disabled="disabled" *ngIf="this.currentPayment.PurchaseContractID.length > 0;" matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentPayment.DisplayValue">
                <mat-icon matSuffix style="cursor: pointer;color: red;" *ngIf="this.currentPayment.PurchaseContractID.length > 0;" (click)="this.currentPayment.PurchaseContractID = '';this.currentPayment.DisplayValue = '';this.currentPayment.PurchaseContractDetailsID = null">close</mat-icon>
                <mat-icon matSuffix style="cursor: pointer;color: red;" *ngIf="!this.currentPayment.PurchaseContractID.length > 0 && SearchedPurchaseContracts != null;" (click)="this.currentPayment.DisplayValue = ''; SearchedPurchaseContracts = null">close</mat-icon>
            </mat-form-field>
  
            <div class="InvoiceSearchContainer" *ngIf="SearchedPurchaseContracts != null;">
                <div class="InvoiceSearchResult" *ngFor="let r of this.SearchedPurchaseContracts; let j=index;" (click)="SelectPurchaseContractForPaymentSearch(r);">
                   <div class="InvoiceSearchResultCol">
                    {{r.AccountingNumber.DisplayValue}}
                   </div>
                   <div class="InvoiceSearchResultCol" style="width: 40%;">
                    {{r.Supplier.Name}}
                   </div>
                   <div class="InvoiceSearchResultCol">
                    {{r.EventRegisterUIDate}}
                   </div>
                   <div class="InvoiceSearchResultCol">
                    {{r.Total.TotalQtyPriceVAT}} {{r.Currency.Name}}
                   </div>
                </div>
            </div>
        </div>
  
        <div *ngIf="this.currentPayment.Category.ID == 1;">
            <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
                <mat-label>{{ 'AssociatedSpending' | translate }}*</mat-label>
                <input *ngIf="this.currentPayment.SpendingID == null;" matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentPayment.DisplayValue" (click)="SearchSpendings(this.currentPayment.DisplayValue);" (keyup)="SearchSpendings(this.currentPayment.DisplayValue);">
                <input disabled="disabled" *ngIf="this.currentPayment.SpendingID != null;" matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentPayment.DisplayValue">
                <mat-icon matSuffix style="cursor: pointer;color: red;" *ngIf="this.currentPayment.SpendingID != null;" (click)="this.currentPayment.SpendingID = null;this.currentPayment.DisplayValue = '';this.currentPayment.PurchaseContractDetailsID = null">close</mat-icon>
                <mat-icon matSuffix style="cursor: pointer;color: red;" *ngIf="!this.currentPayment.SpendingID != null && Spendings != null;" (click)="this.currentPayment.DisplayValue = '';this.currentPayment.SpendingID = null;">close</mat-icon>
            </mat-form-field>
  
            <div class="InvoiceSearchContainer" *ngIf="Spendings != null;">
                <div class="InvoiceSearchResult" *ngFor="let s of this.Spendings; let j=index;" (click)="SelectSpendingForPaymentSearch(s);">
                   <div class="InvoiceSearchResultCol" style="width: 60%;">
                    {{s.Partner.Name}}
                   </div>
                   <div class="InvoiceSearchResultCol">
                    {{s.DocumentDateUI}}
                   </div>
                   <div class="InvoiceSearchResultCol">
                    {{s.Total.TotalQtyPriceVAT}} {{s.Currency.Name}}
                   </div>
                </div>
            </div>
        </div>
  
        <mat-form-field class="PurchaseContractProductsColDropDown" appearance="outline">
            <mat-label>{{ 'PaymentType' | translate }}</mat-label>
            <mat-select name="PaymentType" [(ngModel)]="currentPayment.Type" [compareWith]="compareFn">
              <mat-option *ngFor="let type of this.PaymentTypes;" [value]="type">
                {{type.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
  
          <mat-form-field class="PurchaseContractProductsColDropDown" appearance="outline">
            <mat-label>{{ 'Currency' | translate }}</mat-label>
            <mat-select name="Currency" [(ngModel)]="currentPayment.Currency" [compareWith]="compareFn">
              <mat-option *ngFor="let c of this.Currencies;" [value]="c" (click)="ReselectBankAccount(c);">
                {{c.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
  
          <mat-form-field class="PurchaseContractProductsColDropDown" appearance="outline">
            <mat-label>{{ 'AccountNumber' | translate }}</mat-label>
            <mat-select name="AccountNumber" [(ngModel)]="currentPayment.BankAccount" [compareWith]="compareFn">
              <mat-option *ngFor="let b of this.BankAccounts;" [value]="b">
                {{b.DisplayValue}}
              </mat-option>
            </mat-select>
          </mat-form-field>
  
          <mat-form-field appearance="outline" style="width: 100%;padding: 0;" *ngIf="this.currentPayment.Currency.ExchangeRate > 0;">
            <mat-label>{{ 'PurchaseContracts.ExchangeRate' | translate }}</mat-label>
            <input matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentPayment.Currency.ExchangeRate">
            <mat-icon matSuffix>calculate</mat-icon>
          </mat-form-field>
  
          <mat-form-field class="PurchaseContractProductsColDropDown" appearance="outline">
            <mat-label>{{ 'PurchaseContracts.DecimalPercision' | translate }}</mat-label>
            <mat-select name="DecimalPercision" [(ngModel)]="currentPayment.Currency.DecimalPrecision" [compareWith]="compareFn">
              <mat-option *ngFor="let d of this.DecimalPrecisions;" [value]="d">
                {{d.Meaning}}
              </mat-option>
            </mat-select>
          </mat-form-field>
  
      <mat-form-field appearance="outline" class="PurchaseContractProductsColDropDown">
        <mat-label>{{ 'PaymentDate' | translate }}</mat-label>
        <input matInput [matDatepicker]="dp3" [formControl]="CollectionDate" [(ngModel)]="currentPayment.PaymentDate">
        <mat-datepicker-toggle matSuffix [for]="dp3"></mat-datepicker-toggle>
        <mat-datepicker #dp3></mat-datepicker>
      </mat-form-field>
  
      <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
        <mat-label>{{ 'PaymentValue' | translate }}* [{{this.currentPayment.Currency.Name}}]</mat-label>
        <input matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentPayment.Value">
        <mat-icon matSuffix>monetization_on</mat-icon>
      </mat-form-field>
  
      <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
        <mat-label>{{ 'PaymentExternalID' | translate }}</mat-label>
        <input matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentPayment.PaymentExternalID">
        <mat-icon matSuffix>qr_code_2</mat-icon>
      </mat-form-field>
     </div>
  
     <div class="PopUpCommands">
      <button [disabled]="parent.loading" mat-raised-button color="primary" matTooltip="Submit Cash Collection" class="PopGeneralCommandButton" (click)="ShowSuggestedPaymentModifier = false;">
          <span>{{'UpdatePayment' | translate}}</span>
    </button>
    </div>
  </div>
  
  <div class="animated fadeInDown CashCollectionContainer" *ngIf="ShowPaymentContainer">
    <div class="PopUpCloseContainer" (click)="ShowPaymentContainer = false;">
      <i class="material-icons">close</i>
    </div>
  
    <div class="PopUpTitleContainer">
      <p *ngIf="this.currentPayment.ID > 0;">{{ 'UpdatePayment' | translate }}</p>
      <p *ngIf="!this.currentPayment.ID > 0;">{{ 'NewPayment' | translate }}</p>
     </div>
  
     <div class="PopUpBody" style="margin-top: 20px;">
        
        <div class="currentPaymentRadioGroupContainer">
            <mat-radio-group
            [(ngModel)]="currentPayment.Category">
            <mat-radio-button class="example-radio-button" *ngFor="let c of this.PaymentCategories" [value]="c" style="margin-right: 10px;">
              {{c.Name}}
            </mat-radio-button>
          </mat-radio-group>
        </div>
  
        <mat-form-field class="PurchaseContractProductsColDropDown" appearance="outline">
            <mat-label>{{ 'PaymentType' | translate }}</mat-label>
            <mat-select name="PaymentType" [(ngModel)]="currentPayment.Type" [compareWith]="compareFn">
              <mat-option *ngFor="let type of this.PaymentTypes;" [value]="type">
                {{type.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
  
          <mat-form-field class="PurchaseContractProductsColDropDown" appearance="outline">
            <mat-label>{{ 'Currency' | translate }}</mat-label>
            <mat-select name="Currency" [(ngModel)]="currentPayment.Currency" [compareWith]="compareFn">
              <mat-option *ngFor="let c of this.Currencies;" [value]="c" (click)="ReselectBankAccount(c);">
                {{c.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
  
          <mat-form-field class="PurchaseContractProductsColDropDown" appearance="outline">
            <mat-label>{{ 'AccountNumber' | translate }}</mat-label>
            <mat-select name="AccountNumber" [(ngModel)]="currentPayment.BankAccount" [compareWith]="compareFn">
              <mat-option *ngFor="let b of this.BankAccounts;" [value]="b">
                {{b.DisplayValue}}
              </mat-option>
            </mat-select>
          </mat-form-field>
  
          <mat-form-field appearance="outline" style="width: 100%;padding: 0;" *ngIf="this.currentPayment.Currency.ExchangeRate > 0;">
            <mat-label>{{ 'PurchaseContracts.ExchangeRate' | translate }}</mat-label>
            <input matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentPayment.Currency.ExchangeRate">
            <mat-icon matSuffix>calculate</mat-icon>
          </mat-form-field>
  
          <mat-form-field class="PurchaseContractProductsColDropDown" appearance="outline">
            <mat-label>{{ 'PurchaseContracts.DecimalPercision' | translate }}</mat-label>
            <mat-select name="DecimalPercision" [(ngModel)]="currentPayment.Currency.DecimalPrecision" [compareWith]="compareFn">
              <mat-option *ngFor="let d of this.DecimalPrecisions;" [value]="d">
                {{d.Meaning}}
              </mat-option>
            </mat-select>
          </mat-form-field>
  
      <mat-form-field appearance="outline" class="PurchaseContractProductsColDropDown">
        <mat-label>{{ 'PaymentDate' | translate }}</mat-label>
        <input matInput [matDatepicker]="dp3" [formControl]="CollectionDate" [(ngModel)]="currentPayment.PaymentDate">
        <mat-datepicker-toggle matSuffix [for]="dp3"></mat-datepicker-toggle>
        <mat-datepicker #dp3></mat-datepicker>
      </mat-form-field>
  
      <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
        <mat-label>{{ 'PaymentValue' | translate }}* [{{this.currentPayment.Currency.Name}}]</mat-label>
        <input matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentPayment.Value">
        <mat-icon matSuffix>monetization_on</mat-icon>
      </mat-form-field>
  
      <mat-form-field appearance="outline" style="width: 100%;padding: 0;">
        <mat-label>{{ 'PaymentExternalID' | translate }}</mat-label>
        <input matInput placeholder="Value" autocomplete="off" [(ngModel)]="this.currentPayment.PaymentExternalID">
        <mat-icon matSuffix>qr_code_2</mat-icon>
      </mat-form-field>
  
        <p class="CashCollectRemainingInfo" *ngIf="this.CurrentPurchaseContract.Details.PaymentRemainingValue >= 0;">{{'RemainingToPay' | translate}}: {{this.CurrentPurchaseContract.Details.PaymentRemainingValue}} {{this.CurrentPurchaseContract.Currency.Name}}</p>
        <p class="CashCollectRemainingInfo" *ngIf="this.CurrentPurchaseContract.Details.PaymentRemainingValue < 0;">{{'OverPayed' | translate}}: {{this.CurrentPurchaseContract.Details.PaymentRemainingValue}} {{this.CurrentPurchaseContract.Currency.Name}}</p>
     </div>
  
     <div class="PopUpCommands">
  <button *ngIf="!this.currentPayment.ID > 0;" [disabled]="parent.loading" mat-raised-button color="primary" matTooltip="Submit Cash Collection" class="PopGeneralCommandButton" (click)="AddPayment();ShowPaymentContainer = false;">
      <span>{{'AddPayment' | translate}}</span>
  </button>
    </div>
  </div>

  <div class="InfoQuestion animated fadeInDown" *ngIf="ShowDeactivateDocumentQuestion">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="ShowDeactivateDocumentQuestion = false; CurrentPurchaseContract = null;">close</i>
    </div>
    <div class="InfoQuestionTitle">
      {{ 'DocumentDeactivationTitle' | translate }}
    </div>
    <div class="InfoQuestionBody">
      {{ 'DocumentDeactivationDescription' | translate }}
    </div>
  
    <div class="InfoQuestionCommands">
      <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowDeactivateDocumentQuestion = false; CurrentPurchaseContract = null;">{{ 'No' | translate }}</button>
      <button [disabled]="this.parent.loading" mat-raised-button color="primary" class="InfoQuestionButton" (click)="ShowDeactivateDocumentQuestion = false;CancelPurchaseContract(CurrentPurchaseContract);">{{ 'Yes' | translate }}</button>
    </div>
  </div>
  
  <div class="InfoQuestion animated fadeInDown" *ngIf="ShowReactivateDocumentQuestion">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="ShowReactivateDocumentQuestion = false; CurrentPurchaseContract = null;">close</i>
    </div>
    <div class="InfoQuestionTitle">
      {{ 'DocumentReactivationTitle' | translate }}
    </div>
    <div class="InfoQuestionBody">
      {{ 'DocumentReactivationDescription' | translate }}
    </div>
  
    <div class="InfoQuestionCommands">
      <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowReactivateDocumentQuestion = false; CurrentPurchaseContract = null;">{{ 'No' | translate }}</button>
      <button [disabled]="this.parent.loading" mat-raised-button color="primary" class="InfoQuestionButton" (click)="ShowReactivateDocumentQuestion = false;ActivatePurchaseContract(CurrentPurchaseContract);">{{ 'Yes' | translate }}</button>
    </div>
  </div>
  
  <div *ngIf="showEditPartnerPopUp" class="animated fadeInDown NewPartnerPopUp">
      <div class="PopUpCloseContainer" (click)="showEditPartnerPopUp = false;">
        <i class="material-icons">close</i>
      </div>
      <div class="PopUpTitleContainer">
       <p>{{ 'Partners.EditPartner' | translate }}</p>
      </div>
  
      <div class="PopUpBody">
  
        <p class="PopUpBodySubTitle">{{ 'Partners.PartnerWindow.General' | translate }}</p>
  
        <form [formGroup]="currentPartner">
          <mat-form-field class="example-full-width PopUpBodySemiTextBox">
            <mat-label>{{ 'Partners.VAT' | translate }}</mat-label>
            <input matInput placeholder="ex. RO1234567" value="" autocomplete="off" formControlName="VAT">
            <i class="material-icons CheckEUVATButton" (click)="GetPartnerEUData(this.currentPartner, false);" *ngIf="this.currentPartner.controls['VAT'].value != null && this.currentPartner.controls['VAT'].value.length;">cloud_download</i>
          </mat-form-field>
  
          <mat-form-field class="example-full-width PopUpBodySemiTextBox">
            <mat-label>{{ 'Partners.UPN' | translate }}</mat-label>
            <input matInput placeholder="ex. CNP - RO" value="" autocomplete="off" formControlName="UPN">
          </mat-form-field>
  
          <mat-form-field class="example-full-width PopUpBodySemiTextBox">
            <mat-label>{{ 'Partners.PartnerWindow.Name' | translate }}</mat-label>
            <input matInput placeholder="" value="" autocomplete="off" formControlName="Name" required>
          </mat-form-field>
  
          <mat-form-field class="example-full-width PopUpBodySemiTextBox">
            <mat-label>{{ 'Partners.PartnerWindow.COCRegNumber' | translate }}</mat-label>
            <input matInput placeholder="" value="" autocomplete="off" formControlName="COCRegNumber">
          </mat-form-field>
  
          <div class="PopUpBodySemiTextBox">
            <mat-slide-toggle formControlName="TaxPayer">{{ 'Partners.PartnerWindow.TaxPayer' | translate }}</mat-slide-toggle>
          </div>
  
          <p class="PopUpBodySubTitle">{{ 'Partners.PartnerWindow.Address' | translate }}</p>
  
          <div class="PopUpBodySemiTextBox">
            <mat-form-field>
              <mat-label>{{ 'Partners.PartnerWindow.ChooseCountry' | translate }}</mat-label>
              <mat-select name="country" [compareWith]="compareFn" formControlName="Country" required>
                <mat-option *ngFor="let c of parent.masterData.Countries" [value]="c">
                  {{c.Name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
  
          <mat-form-field class="example-full-width PopUpBodySemiTextBox">
            <mat-label>{{ 'Partners.PartnerWindow.StateProvince' | translate }}</mat-label>
            <input matInput placeholder="" value="" autocomplete="off" formControlName="StateProvince" required>
          </mat-form-field>
  
          <mat-form-field class="example-full-width PopUpBodySemiTextBox">
            <mat-label>{{ 'Partners.PartnerWindow.City' | translate }}</mat-label>
            <input matInput placeholder="" value="" autocomplete="off" formControlName="City" required>
          </mat-form-field>
  
          <mat-form-field class="example-full-width PopUpBodySemiTextBox">
            <mat-label>{{ 'Partners.PartnerWindow.AddressLine' | translate }}</mat-label>
            <input matInput placeholder="" value="" autocomplete="off" formControlName="AddressLine" required>
          </mat-form-field>
  
          <p class="PopUpBodySubTitle">{{ 'Partners.PartnerWindow.Bank' | translate }}</p>
  
          <div class="PopUpBodySemiTextBox">
            <mat-form-field>
              <mat-label>{{ 'Partners.PartnerWindow.ChooseBank' | translate }}</mat-label>
              <mat-select name="bank" [compareWith]="compareFn" formControlName="Bank">
                <mat-option *ngFor="let b of parent.masterData.Banks" [value]="b">
                  {{b.Name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
  
          <mat-form-field class="example-full-width PopUpBodySemiTextBox">
            <mat-label>{{ 'Partners.PartnerWindow.BankAccountNumber' | translate }}</mat-label>
            <input matInput placeholder="" value="" autocomplete="off" formControlName="BankAccount">
          </mat-form-field>
  
          <p class="PopUpBodySubTitle">{{ 'Partners.PartnerWindow.ContactInfo' | translate }}</p>
  
          <mat-form-field class="example-full-width PopUpBodySemiTextBox">
            <mat-label>{{ 'Login.Email' | translate }}</mat-label>
            <input matInput placeholder="" value="" autocomplete="off" formControlName="Email">
          </mat-form-field>
  
          <mat-form-field class="example-full-width PopUpBodySemiTextBox">
            <mat-label>{{ 'Partners.PartnerWindow.Name' | translate }}</mat-label>
            <input matInput placeholder="" value="" autocomplete="off" formControlName="ContactName">
          </mat-form-field>
  
          <mat-form-field class="example-full-width PopUpBodySemiTextBox">
            <mat-label>{{ 'Login.Phone' | translate }}</mat-label>
            <input matInput placeholder="" value="" autocomplete="off" formControlName="Phone">
          </mat-form-field>
        </form>
  
      </div>
  
      <div class="PopUpCommands">
        <button [disabled]="parent.loading" mat-raised-button color="primary" matTooltip="Submit Partner" class="PopGeneralCommandButton" (click)="UpdatePartner();">Update Partner</button>
      </div>
    </div>
  
  <div class="animated fadeInDown DocumentContainer" *ngIf="showPurchaseContractVisualizer">
    <div class="PopUpCloseContainer" (click)="showPurchaseContractVisualizer = false;">
      <i class="material-icons">close</i>
    </div>
  
    <div class="PopUpTitleContainer">
      <p class="SectionTitle" style="margin-top: 0%;" *ngIf="this.CurrentPurchaseContract.ID == null && !DocumentBodyLoading;">
        <span *ngIf="!IsStorno;">{{ 'PurchaseContracts.NewPurchaseContract' | translate }}</span>
        <span *ngIf="IsStorno;">{{ 'PurchaseContracts.StornoPurchaseContract' | translate }}</span>
        </p>
        <p class="SectionTitle" style="margin-top: 0%;" *ngIf="this.CurrentPurchaseContract.ID != null && !DocumentBodyLoading;">
          <span>
            {{CurrentPurchaseContract.AccountingNumber.DisplayValue}} 
            / {{CurrentPurchaseContract.EventRegisterUI}}
          </span>
        </p>
     </div> 
  
     <div class="PopUpCommands" style="margin-left: 2.5%;box-shadow: 0 4px 3px -2px rgb(0 0 0 / 30%);width: 95%;">
      <button mat-raised-button color="primary" class="VizualizeCommandButton" (click)="ExportPurchaseContract(CurrentPurchaseContract);">
        <i class="material-icons">file_copy</i>
        <span>{{ 'PurchaseContracts.Document.Export' | translate }}</span>
      </button>
  
      <button mat-raised-button class="VizualizeCommandButton" (click)="PrintPurchaseContract(CurrentPurchaseContract);">
        <i class="material-icons">print</i>
        <span>{{ 'PurchaseContracts.Document.Print' | translate }}</span>
      </button>
  
      <button mat-raised-button class="VizualizeCommandButton" [matMenuTriggerFor]="menuPurchaseContract">
        <i class="material-icons">settings</i>
        <span>{{ 'PurchaseContracts.Document.Actions' | translate }}</span>
      </button>   
      
      <mat-menu #menuPurchaseContract="matMenu">
        <button mat-menu-item (click)="ViewPurchaseContract(CurrentPurchaseContract);" class="PurchaseContractMenuButton" *ngIf="CurrentPurchaseContract.DocumentStatus.ID != -1;">
            <i class="material-icons">mode_edit</i>
            <span>{{ 'PurchaseContracts.Table.ButtonMenu.modify' | translate }}</span>
        </button>
        <button mat-menu-item class="PurchaseContractMenuButton" (click)="GenerateStorno(CurrentPurchaseContract);" *ngIf="CurrentPurchaseContract.DocumentStatus.ID != -1 && CurrentPurchaseContract.IsStorno != true;">
            <i class="material-icons">settings_backup_restore</i>
            <span>{{ 'PurchaseContracts.Table.ButtonMenu.stornate' | translate }}</span>
        </button>
        <button mat-menu-item class="PurchaseContractMenuButton" *ngIf="CurrentPurchaseContract.DocumentStatus.ID == 1;" (click)="ShowDeactivateDocumentQuestion = true;">
            <i class="material-icons">close</i>
            <span>{{ 'PurchaseContracts.Table.ButtonMenu.cancelDoc' | translate }}</span>
        </button>
        <button mat-menu-item class="PurchaseContractMenuButton" *ngIf="CurrentPurchaseContract.DocumentStatus.ID == -1;" (click)="ShowReactivateDocumentQuestion = true;">
            <i class="material-icons">verified</i>
            <span>{{ 'PurchaseContracts.Table.ButtonMenu.reactivateDoc' | translate }}</span>
        </button>
        <button mat-menu-item class="PurchaseContractMenuButton" (click)="DeletePurchaseContract(CurrentPurchaseContract);">
            <i class="material-icons">delete_forever</i>
            <span>{{ 'PurchaseContracts.Table.ButtonMenu.delete' | translate }}</span>
        </button>
       </mat-menu>

       <button [disabled]="this.DocumentBodyLoading || this.parent.loading" (click)="AutoPrintDocument(this.CurrentPurchaseContract);" mat-raised-button class="VizualizeCommandButton" matTooltip="{{ 'AutoPrintDesc' | translate }}" matTooltipClass='neutral-tool-tip' style="outline: none;float: right;">
        <i class="material-icons">print</i>
        <span>{{ 'AutoPrint' | translate }}</span>
      </button>
  
      <mat-progress-bar mode="query" class="DocumentProgressBar" *ngIf="DocumentBodyLoading"></mat-progress-bar>
    </div>
  
     <div class="PopUpBody" style="max-height: 75vh;" *ngIf="!CurrentPurchaseContract.IsStorno">
       <div class="DocumentBody">
  
        <p class="DocumentBodyCanceled" *ngIf="CurrentPurchaseContract.DocumentStatus.ID == -1;">anulata</p>
  
         <div style="border: solid 1px #333;">
          
          <table style="width: 100%;margin-bottom: 20px;border-bottom: solid 1px #333;margin-top: 20px;">
            <tbody>
              <tr style="width: 100%;font-weight: 600;font-size: 16px;text-align: center;">
                <td>{{ 'PurchaseContractsTitle' | translate }}</td>
              </tr>
  
              <table style="width: 100%;margin-top: 25px;">
                <tbody>
                  <tr style="width: 70%;text-align: left;float: left;padding-left: 20px;">
                    <td>{{ 'PurchaseContracts.Document.Unity' | translate }}: {{this.parent.Company.Name}}</td>
                  </tr>
                  <tr style="width: 30%;text-align: left;float: left;">
                    <td>{{ 'PurchaseContracts.Document.DocNr' | translate }}:  {{CurrentPurchaseContract.AccountingNumber.AccountingSeries.Series}}{{(CurrentPurchaseContract.AccountingNumber.Number)}}</td>
                  </tr>
                </tbody>
              </table>
  
              <table style="width: 100%;margin-top: 5px;">
                <tbody>
                  <tr style="width: 70%;text-align: left;float: left;padding-left: 20px;margin-bottom: 20px;">
                    <td>{{ 'PurchaseContracts.Document.Administrations' | translate }}: 
                      <span *ngFor="let a of this.CurrentPurchaseContract.Administrations; let i=index;">{{a.Name}}; </span>
                    </td>
                  </tr>
                  <tr style="width: 30%;text-align: left;float: left;">
                    <td>{{ 'PurchaseContracts.Document.Date' | translate }}: {{CurrentPurchaseContract.EventRegisterUI}}</td>
                  </tr>
                </tbody>
              </table>
             
            </tbody>
          </table>
  
          <table style="width: 100%;border-bottom: solid 1px #333;">
            <tbody>
              <table style="width: 100%;margin-top: 5px;">
                <tbody>
                  <tr style="width: 100%;text-align: left;float: left;padding-left: 20px;">
                    <td>
                      {{ 'PurchaseContracts.Document.UndersignedTitle' | translate }} {{this.CurrentPurchaseContract.Supplier.Name}}
                    </td>
                  </tr>
                </tbody>
              </table>
  
              <table style="width: 100%;margin-top: 5px;">
                <tbody>
                  <tr style="width: 100%;text-align: left;float: left;padding-left: 20px;">
                    <td>
                      {{ 'PurchaseContracts.Document.SupplyingDocuments' | translate }}: {{this.CurrentPurchaseContract.DocumentNumber}}
                    </td>
                  </tr>
                </tbody>
              </table>
  
              <table style="width: 100%;margin-top: 5px;">
                <tbody>
                  <tr style="width: 100%;text-align: left;float: left;padding-left: 20px;">
                    <td>
                      {{ 'PurchaseContracts.Document.Delegate' | translate }}: {{this.CurrentPurchaseContract.Details.Delegate}}
                    </td>
                  </tr>
                </tbody>
              </table>
  
              <table style="width: 100%;margin-top: 5px;">
                <tbody>
                  <tr style="width: 100%;text-align: left;float: left;padding-left: 20px;">
                    <td>
                      {{ 'PurchaseContracts.Document.Observations' | translate }}: {{this.CurrentPurchaseContract.Details.Observations}}
                    </td>
                  </tr>
                </tbody>
              </table>
              
              <table style="width: 100%;margin-top: 5px;margin-bottom: 20px;">
                <tbody>
                  <tr style="width: 100%;text-align: left;float: left;padding-left: 20px;">
                    <td>
                      {{ 'PurchaseContracts.Document.Auto' | translate }}: {{this.CurrentPurchaseContract.Details.Auto}}
                    </td>
                  </tr>
                </tbody>
              </table>
  
            </tbody>
          </table>
  
          <table style="width: 100%;">
            <tbody>
              
              <table style="width: 100%;font-size: 12px;">
                <tbody>
                  <tr style="width: 100%;">
  
                    <td style="width: 50%;float: left;padding: 0;">
                      <table style="width: 100%;">
                      <tbody>
                        <tr>
                          <td style="height: 70px;text-align: center;width: 10%;padding: 0;">{{ 'PurchaseContracts.Document.Table.Nr' | translate }}</td>
                          <td style="height: 70px;text-align: center;border-left: solid 1px #333;width: 60%;padding: 0;">{{ 'PurchaseContracts.Document.Table.Name' | translate }}</td>
                          <td style="height: 70px;text-align: center;border-left: solid 1px #333;width: 10%;padding: 0;">{{ 'PurchaseContracts.Document.Table.MU' | translate }}</td>
                          <td style="height: 70px;text-align: center;border-left: solid 1px #333;width: 20%;padding-left: 10px;padding-right: 10px;padding: 5;">{{ 'PurchaseContracts.Document.Table.DocQuantity' | translate }}</td>
                        </tr>
                      </tbody>
                      </table>
                    </td>
  
                    <td style="width: 50%;float: left;padding: 0;">
                      <table style="width: 100%;">
                      <tbody>
  
                        <tr>
                        <td style="padding: 0;">
                          <table style="width: 100%;height: 35px;border-bottom: solid 1px #333;">
                            <tbody>
                              <tr>
                                <td style="width: 100%;text-align: center;padding: 0;border-left: solid 1px #333;">{{ 'PurchaseContracts.Document.Table.Received' | translate }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                        </tr>
  
                        <tr>
                          <td style="padding: 0;">
                            <table style="width: 100%;height: 35px;padding: 0;">
                              <tbody>
                                <tr>
                                  <td style="text-align: center;width: 15%;padding: 0;">{{ 'PurchaseContracts.Document.Table.Quantity' | translate }}</td>
                                  <td style="text-align: center;width: 30%;padding: 0;">{{ 'PurchaseContracts.Document.Table.UnitPrice' | translate }} ({{CurrentPurchaseContract.Currency.Name}})</td>
                                  <td style="text-align: center;width: 30%;padding: 0;">{{ 'PurchaseContracts.Document.Table.TotalValue' | translate }} ({{CurrentPurchaseContract.Currency.Name}})</td>
                                  <td style="text-align: center;width: 25%;padding: 0;">{{ 'PurchaseContracts.Document.Table.VATValue' | translate }}</td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                          </tr>
  
                      </tbody>
                      </table>
                    </td>
  
                  </tr>
  
                  <tr style="width: 100%;">
  
                   <td style="padding: 0;">
                    <table style="width: 100%;">
                      <tbody>
                        <tr style="width: 100%;height: 20px;line-height: 20px;border-top: solid 1px #ddd;" *ngFor="let p of this.CurrentPurchaseContract.Products; let i=index;">
                          <td style="width: 5%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                            {{i + 1}}
                          </td>
              
                          <td style="width: 30%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                            ({{p.ProductPurchaseContractInfo.Code}}) {{p.ProductPurchaseContractInfo.Name}}
                          </td>
              
                          <td style="width: 5%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                            {{p.ProductPurchaseContractInfo.MeasuringUnit.Name}}
                          </td>
              
                          <td style="width: 10%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                            {{p.ProductPurchaseContractInfo.DocQuantity}}
                          </td>
              
                          <td style="width: 7.5%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                            {{p.ProductPurchaseContractInfo.Quantity}}
                          </td>
              
                          <td style="width: 15%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                            {{p.ProductPurchaseContractInfo.Price.UIUnitPrice}}
                          </td>
              
                          <td style="width: 15%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                            {{p.ProductPurchaseContractInfo.Price.UIQtyPrice}}
                          </td>
              
                          <td style="width: 12.5%;height: 20px;text-align: center;padding: 0;">
                            {{p.ProductPurchaseContractInfo.Price.TotalVATValue}}
                          </td>
                        </tr>
                      </tbody>
                      </table>
                   </td>
  
                  </tr>
  
                  <tr style="width: 100%;border-top: solid 1px #333;">
  
                    <td style="padding: 0;">
                     <table style="width: 100%;">
                       <tbody>
                         <tr style="width: 100%;height: 20px;line-height: 20px;">
                           <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 30%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 10%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 7.5%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 15%;height: 20px;text-align: center;padding: 0;">
                            
                           </td>
               
                           <td style="width: 15%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 12.5%;height: 20px;text-align: center;padding: 0;">
                            
                           </td>
                         </tr>
                       </tbody>
                       </table>
                    </td>
   
                   </tr>
  
                   <tr style="width: 100%;border-top: solid 1px #333;">
  
                    <td style="padding: 0;">
                     <table style="width: 100%;">
                       <tbody>
                         <tr style="width: 100%;height: 20px;line-height: 20px;">
                           <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 30%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 10%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 7.5%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 15%;height: 20px;text-align: center;padding: 0;border-right: solid 1px #333;">
                            {{ 'PurchaseContracts.Document.Table.TotalNOVAT' | translate }}:
                           </td>
               
                           <td style="width: 15%;height: 20px;text-align: center;padding: 0;border-right: solid 1px #333;">
                            {{ 'PurchaseContracts.Document.Table.VATValue' | translate }}:
                           </td>
               
                           <td style="width: 12.5%;height: 20px;text-align: center;padding: 0;">
                            {{ 'PurchaseContracts.Document.Table.Total' | translate }}:
                           </td>
                         </tr>
                       </tbody>
                       </table>
                    </td>
   
                   </tr>
  
                  <tr style="width: 100%;border-top: solid 1px #333;">
  
                    <td style="padding: 0;">
                     <table style="width: 100%;">
                       <tbody>
                         <tr style="width: 100%;height: 20px;line-height: 20px;">
                           <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 30%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 10%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 7.5%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 15%;height: 20px;text-align: center;padding: 0;border-right: solid 1px #333;font-weight: bold;">
                            {{CurrentPurchaseContract.Total.TotalQtyPriceNOVAT}} {{CurrentPurchaseContract.Currency.Name}}
                           </td>
               
                           <td style="width: 15%;height: 20px;text-align: center;padding: 0;border-right: solid 1px #333;font-weight: bold;">
                            {{CurrentPurchaseContract.Total.TotalVAT}} {{CurrentPurchaseContract.Currency.Name}}
                           </td>
               
                           <td style="width: 12.5%;height: 20px;text-align: center;padding: 0;font-weight: bold;">
                            {{CurrentPurchaseContract.Total.TotalQtyPriceVAT}} {{CurrentPurchaseContract.Currency.Name}}
                           </td>
                         </tr>
                       </tbody>
                       </table>
                    </td>
   
                   </tr>
  
                   <tr style="width: 100%;border-top: solid 1px #333;">
  
                    <td style="padding: 0;">
                     <table style="width: 100%;">
                       <tbody>
                         <tr style="width: 100%;height: 20px;line-height: 20px;">
                           <td style="width: 40%;height: 20px;text-align: left;padding: 0;padding-left: 5px;border-right: solid 1px #333;">
                            {{ 'PurchaseContracts.Document.PurchaseContractCommitee' | translate }}: {{CurrentPurchaseContract.Details.PurchaseContractCommittee}}
                           </td>
               
                           <td style="width: 60%;height: 20px;text-align: left;padding: 0;padding-left: 5px;">
                            {{ 'PurchaseContracts.Document.ReceivedInAdministration' | translate }}:
                           </td>
                         </tr>
                       </tbody>
                       </table>
                    </td>
   
                   </tr>
  
                   <tr style="width: 100%;border-top: solid 1px #333;">
  
                    <td style="padding: 0;">
                     <table style="width: 100%;">
                       <tbody>
                         <tr style="width: 100%;height: 20px;line-height: 20px;">
                           <td style="width: 35%;height: 20px;text-align: left;padding: 0;padding-left: 5px;">
                            {{ 'PurchaseContracts.Document.FullName' | translate }}:
                           </td>
               
                           <td style="width: 5%;height: 20px;text-align: left;padding: 0;padding-right: 5px;">
                            {{ 'PurchaseContracts.Document.Signature' | translate }}
                           </td>
               
                           <td style="width: 32.5%;height: 20px;text-align: left;padding: 0;padding-left: 5px;border-left: solid 1px #333;">
                            {{ 'PurchaseContracts.Document.FullName' | translate }}:
                           </td>
               
                           <td style="width: 27.5%;height: 20px;text-align: left;padding: 0;padding-left: 5px;">
                            {{ 'PurchaseContracts.Document.Signature' | translate }}
                           </td>
                          
                         </tr>
                       </tbody>
                       </table>
                    </td>
   
                   </tr>
  
                   <tr style="width: 100%;border-top: solid 1px #333;">
  
                    <td style="padding: 0;">
                     <table style="width: 100%;">
                       <tbody>
                         <tr style="width: 100%;height: 20px;line-height: 20px;">
                           <td style="width: 40%;height: 50px;text-align: left;padding: 0;padding-left: 5px;">
                             
                           </td>
               
                           <td style="width: 60%;height: 50px;text-align: left;padding: 0;padding-left: 5px;border-left: solid 1px #333;">
                            {{CurrentPurchaseContract.UpdatingUser.UserName}}
                           </td>
                          
                         </tr>
                       </tbody>
                       </table>
                    </td>
   
                   </tr>
  
                   <tr style="width: 100%;border-top: solid 1px #333;">
  
                    <td style="padding: 0;">
                     <table style="width: 100%;">
                       <tbody>
                         <tr style="width: 100%;height: 20px;line-height: 20px;">
                           <td style="width: 40%;height: 20px;text-align: left;padding: 0;padding-left: 5px;">
                            {{ 'PurchaseContracts.Document.Currency' | translate }}: {{CurrentPurchaseContract.Details.CurrencyRow}}
                           </td>
                         </tr>
                       </tbody>
                       </table>
                    </td>
   
                   </tr>
  
                </tbody>
              </table>
  
            </tbody>
          </table>
  
         </div>
  
       </div>
     </div>
  
     <div class="PopUpBody" style="max-height: 75vh;" *ngIf="CurrentPurchaseContract.IsStorno">
      <div class="DocumentBody">
  
       <p class="DocumentBodyCanceled" *ngIf="CurrentPurchaseContract.DocumentStatus.ID == -1;">anulata</p>
  
        <div style="border: solid 1px #333;">
          <table style="width: 100%;margin-bottom: 20px;border-bottom: solid 1px #333;margin-top: 20px;">
            <tbody>
              <tr style="width: 100%;font-weight: 600;font-size: 16px;text-align: center;">
                <td>{{ 'PurchaseContracts.Document.DocumentStorno.ReturnTitle' | translate }}</td>
              </tr>
  
              <table style="width: 100%;margin-top: 25px;">
                <tbody>
                  <tr style="width: 70%;text-align: left;float: left;padding-left: 20px;">
                    <td>{{ 'PurchaseContracts.Document.Unity' | translate }}: {{this.parent.Company.Name}}</td>
                  </tr>
                  <tr style="width: 30%;text-align: left;float: left;">
                    <td>{{ 'PurchaseContracts.Document.DocNr' | translate }}:  {{CurrentPurchaseContract.AccountingNumber.AccountingSeries.Series}}{{(CurrentPurchaseContract.AccountingNumber.Number)}}</td>
                  </tr>
                </tbody>
              </table>
  
              <table style="width: 100%;margin-top: 5px;">
                <tbody>
                  <tr style="width: 70%;text-align: left;float: left;padding-left: 20px;margin-bottom: 20px;">
                    <td>{{ 'PurchaseContracts.Document.Administrations' | translate }}: 
                      <span *ngFor="let a of this.CurrentPurchaseContract.Administrations; let i=index;">{{a.Name}}; </span>
                    </td>
                  </tr>
                  <tr style="width: 30%;text-align: left;float: left;">
                    <td>{{ 'PurchaseContracts.Document.Date' | translate }}: {{CurrentPurchaseContract.EventRegisterUI}}</td>
                  </tr>
                </tbody>
              </table>
             
            </tbody>
          </table>
  
          <table style="width: 100%;border-bottom: solid 1px #333;">
  
            <tbody>
              <table style="width: 100%;margin-top: 5px;margin-bottom: 25px;">
                <tbody>
                  <tr style="width: 100%;text-align: left;float: left;padding-left: 20px;">
                    <td>
                      {{ 'PurchaseContracts.Document.DocumentStorno.ReturnSubTitle' | translate }} {{this.CurrentPurchaseContract.Supplier.Name}} 
                      {{ 'PurchaseContracts.Document.DocumentStorno.OnDocumentBasis' | translate }} {{CurrentPurchaseContract.DocumentNumber}} / {{CurrentPurchaseContract.DocumentDate}}
                    </td>
                  </tr>
                </tbody>
              </table>
            </tbody>
  
          </table>
  
          <table style="width: 100%;">
            <tbody>
              
              <table style="width: 100%;font-size: 12px;">
                <tbody>
                  <tr style="width: 100%;">
  
                    <td style="width: 50%;float: left;padding: 0;">
                      <table style="width: 100%;">
                      <tbody>
                        <tr>
                          <td style="height: 70px;text-align: center;width: 10%;padding: 0;">{{ 'PurchaseContracts.Document.Table.Nr' | translate }}</td>
                          <td style="height: 70px;text-align: center;border-left: solid 1px #333;width: 60%;padding: 0;">{{ 'PurchaseContracts.Document.Table.Name' | translate }}</td>
                          <td style="height: 70px;text-align: center;border-left: solid 1px #333;width: 10%;padding: 0;">{{ 'PurchaseContracts.Document.Table.MU' | translate }}</td>
                          <td style="height: 70px;text-align: center;border-left: solid 1px #333;width: 20%;padding-left: 10px;padding-right: 10px;padding: 5;">{{ 'PurchaseContracts.Document.Table.DocQuantity' | translate }}</td>
                        </tr>
                      </tbody>
                      </table>
                    </td>
  
                    <td style="width: 50%;float: left;padding: 0;">
                      <table style="width: 100%;">
                      <tbody>
  
                        <tr>
                        <td style="padding: 0;">
                          <table style="width: 100%;height: 35px;border-bottom: solid 1px #333;">
                            <tbody>
                              <tr>
                                <td style="width: 100%;text-align: center;padding: 0;border-left: solid 1px #333;">{{ 'PurchaseContracts.Document.Table.Returned' | translate }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                        </tr>
  
                        <tr>
                          <td style="padding: 0;">
                            <table style="width: 100%;height: 35px;padding: 0;">
                              <tbody>
                                <tr>
                                  <td style="text-align: center;width: 15%;padding: 0;">{{ 'PurchaseContracts.Document.Table.Quantity' | translate }}</td>
                                  <td style="text-align: center;width: 30%;padding: 0;">{{ 'PurchaseContracts.Document.Table.UnitPrice' | translate }} ({{CurrentPurchaseContract.Currency.Name}})</td>
                                  <td style="text-align: center;width: 30%;padding: 0;">{{ 'PurchaseContracts.Document.Table.TotalValue' | translate }} ({{CurrentPurchaseContract.Currency.Name}})</td>
                                  <td style="text-align: center;width: 25%;padding: 0;">{{ 'PurchaseContracts.Document.Table.VATValue' | translate }}</td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                          </tr>
  
                      </tbody>
                      </table>
                    </td>
  
                  </tr>
  
                  <tr style="width: 100%;">
  
                   <td style="padding: 0;">
                    <table style="width: 100%;">
                      <tbody>
                        <tr style="width: 100%;height: 20px;line-height: 20px;border-top: solid 1px #ddd;" *ngFor="let p of this.CurrentPurchaseContract.Products; let i=index;">
                          <td style="width: 5%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                            {{i + 1}}
                          </td>
              
                          <td style="width: 30%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                            ({{p.ProductPurchaseContractInfo.Code}}) {{p.ProductPurchaseContractInfo.Name}}
                          </td>
              
                          <td style="width: 5%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                            {{p.ProductPurchaseContractInfo.MeasuringUnit.Name}}
                          </td>
              
                          <td style="width: 10%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                            {{p.ProductPurchaseContractInfo.DocQuantity}}
                          </td>
              
                          <td style="width: 7.5%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                            {{p.ProductPurchaseContractInfo.Quantity}}
                          </td>
              
                          <td style="width: 15%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                            {{p.ProductPurchaseContractInfo.Price.UIUnitPrice}}
                          </td>
              
                          <td style="width: 15%;height: 20px;text-align: center;border-right: solid 1px #333;padding: 0;">
                            {{p.ProductPurchaseContractInfo.Price.UIQtyPrice}}
                          </td>
              
                          <td style="width: 12.5%;height: 20px;text-align: center;padding: 0;">
                            {{p.ProductPurchaseContractInfo.TotalVATValue}}
                          </td>
                        </tr>
                      </tbody>
                      </table>
                   </td>
  
                  </tr>
  
                  <tr style="width: 100%;border-top: solid 1px #333;">
  
                    <td style="padding: 0;">
                     <table style="width: 100%;">
                       <tbody>
                         <tr style="width: 100%;height: 20px;line-height: 20px;">
                           <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 30%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 10%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 7.5%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 15%;height: 20px;text-align: center;padding: 0;">
                            
                           </td>
               
                           <td style="width: 15%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 12.5%;height: 20px;text-align: center;padding: 0;">
                            
                           </td>
                         </tr>
                       </tbody>
                       </table>
                    </td>
   
                   </tr>
  
                   <tr style="width: 100%;border-top: solid 1px #333;">
  
                    <td style="padding: 0;">
                     <table style="width: 100%;">
                       <tbody>
                         <tr style="width: 100%;height: 20px;line-height: 20px;">
                           <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 30%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 10%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 7.5%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 15%;height: 20px;text-align: center;padding: 0;border-right: solid 1px #333;">
                            {{ 'PurchaseContracts.Document.Table.TotalNOVAT' | translate }}:
                           </td>
               
                           <td style="width: 15%;height: 20px;text-align: center;padding: 0;border-right: solid 1px #333;">
                            {{ 'PurchaseContracts.Document.Table.VATValue' | translate }}:
                           </td>
               
                           <td style="width: 12.5%;height: 20px;text-align: center;padding: 0;">
                            {{ 'PurchaseContracts.Document.Table.Total' | translate }}:
                           </td>
                         </tr>
                       </tbody>
                       </table>
                    </td>
   
                   </tr>
  
                  <tr style="width: 100%;border-top: solid 1px #333;">
  
                    <td style="padding: 0;">
                     <table style="width: 100%;">
                       <tbody>
                         <tr style="width: 100%;height: 20px;line-height: 20px;">
                           <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 30%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 5%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 10%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 7.5%;height: 20px;text-align: center;padding: 0;">
                             
                           </td>
               
                           <td style="width: 15%;height: 20px;text-align: center;padding: 0;border-right: solid 1px #333;font-weight: bold;">
                            {{CurrentPurchaseContract.Total.TotalQtyPriceNOVAT}} {{CurrentPurchaseContract.Currency.Name}}
                           </td>
               
                           <td style="width: 15%;height: 20px;text-align: center;padding: 0;border-right: solid 1px #333;font-weight: bold;">
                            {{CurrentPurchaseContract.Total.TotalVAT}} {{CurrentPurchaseContract.Currency.Name}}
                           </td>
               
                           <td style="width: 12.5%;height: 20px;text-align: center;padding: 0;font-weight: bold;">
                            {{CurrentPurchaseContract.Total.TotalQtyPriceVAT}} {{CurrentPurchaseContract.Currency.Name}}
                           </td>
                         </tr>
                       </tbody>
                       </table>
                    </td>
   
                   </tr>
  
                   <tr style="width: 100%;border-top: solid 1px #333;">
  
                    <td style="padding: 0;">
                     <table style="width: 100%;">
                       <tbody>
                         <tr style="width: 100%;height: 20px;line-height: 20px;">
                           <td style="width: 40%;height: 20px;text-align: left;padding: 0;padding-left: 5px;border-right: solid 1px #333;">
                            {{ 'PurchaseContracts.Document.PurchaseContractCommitee' | translate }}: {{CurrentPurchaseContract.Details.PurchaseContractCommittee}}
                           </td>
               
                           <td style="width: 60%;height: 20px;text-align: left;padding: 0;padding-left: 5px;">
                            {{ 'PurchaseContracts.Document.ReceivedInAdministration' | translate }}:
                           </td>
                         </tr>
                       </tbody>
                       </table>
                    </td>
   
                   </tr>
  
                   <tr style="width: 100%;border-top: solid 1px #333;">
  
                    <td style="padding: 0;">
                     <table style="width: 100%;">
                       <tbody>
                         <tr style="width: 100%;height: 20px;line-height: 20px;">
                           <td style="width: 35%;height: 20px;text-align: left;padding: 0;padding-left: 5px;">
                            {{ 'PurchaseContracts.Document.FullName' | translate }}:
                           </td>
               
                           <td style="width: 5%;height: 20px;text-align: left;padding: 0;padding-right: 5px;">
                            {{ 'PurchaseContracts.Document.Signature' | translate }}
                           </td>
               
                           <td style="width: 32.5%;height: 20px;text-align: left;padding: 0;padding-left: 5px;border-left: solid 1px #333;">
                            {{ 'PurchaseContracts.Document.FullName' | translate }}:
                           </td>
               
                           <td style="width: 27.5%;height: 20px;text-align: left;padding: 0;padding-left: 5px;">
                            {{ 'PurchaseContracts.Document.Signature' | translate }}
                           </td>
                          
                         </tr>
                       </tbody>
                       </table>
                    </td>
   
                   </tr>
  
                   <tr style="width: 100%;border-top: solid 1px #333;">
  
                    <td style="padding: 0;">
                     <table style="width: 100%;">
                       <tbody>
                         <tr style="width: 100%;height: 20px;line-height: 20px;">
                           <td style="width: 40%;height: 50px;text-align: left;padding: 0;padding-left: 5px;">
                             
                           </td>
               
                           <td style="width: 60%;height: 50px;text-align: left;padding: 0;padding-left: 5px;border-left: solid 1px #333;">
                            {{CurrentPurchaseContract.UpdatingUser.UserName}}
                           </td>
                          
                         </tr>
                       </tbody>
                       </table>
                    </td>
   
                   </tr>
  
                   <tr style="width: 100%;border-top: solid 1px #333;">
  
                    <td style="padding: 0;">
                     <table style="width: 100%;">
                       <tbody>
                         <tr style="width: 100%;height: 20px;line-height: 20px;">
                           <td style="width: 40%;height: 20px;text-align: left;padding: 0;padding-left: 5px;">
                            {{ 'PurchaseContracts.Document.Currency' | translate }}: {{CurrentPurchaseContract.Details.CurrencyRow}}
                           </td>
                         </tr>
                       </tbody>
                       </table>
                    </td>
   
                   </tr>
  
                </tbody>
              </table>
  
            </tbody>
          </table>
        </div>
  
      </div>
    </div>
  </div>
  
  <div class="InfoQuestion animated fadeInDown" *ngIf="ShowDeleteSpendingQuestion">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="ShowDeleteSpendingQuestion = false; currentSpending = null;">close</i>
    </div>
    <div class="InfoQuestionTitle">
      {{ 'Configuration.DeleteQuestion' | translate }}
    </div>
    <div class="InfoQuestionBody">
      {{ 'Configuration.DeleteQuestionDescription' | translate }}
    </div>
  
    <div class="InfoQuestionCommands">
      <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowDeleteSpendingQuestion = false; currentPayment = null;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
      <button [disabled]="this.parent.loading" mat-raised-button color="warn" class="InfoQuestionButton" (click)="ShowDeleteSpendingQuestion = false;DeletePayment(currentPayment.ID);">{{ 'Configuration.DeleteYesButton' | translate }}</button>
    </div>
  </div>

  <div class="InfoQuestion animated fadeInDown" *ngIf="ShowDeletePCQuestion">
    <div class="InfoQuestionClose">
      <i class="material-icons" (click)="ShowDeletePCQuestion = false; CurrentPurchaseContract = null;">close</i>
    </div>
    <div class="InfoQuestionTitle">
      {{ 'Configuration.DeleteQuestion' | translate }}
    </div>
    <div class="InfoQuestionBody">
      {{ 'Configuration.DeleteQuestionDescription' | translate }}
    </div>
  
    <div class="InfoQuestionCommands">
      <button [disabled]="this.parent.loading" mat-raised-button class="InfoQuestionButton" (click)="ShowDeletePCQuestion = false; CurrentPurchaseContract = null;">{{ 'Configuration.DeleteNoButton' | translate }}</button>
      <button [disabled]="this.parent.loading" mat-raised-button color="warn" class="InfoQuestionButton" (click)="ShowDeletePCQuestion = false;DeletePurchaseContract(CurrentPurchaseContract);">{{ 'Configuration.DeleteYesButton' | translate }}</button>
    </div>
  </div>
  
  <div class="MainTitleBar" style="overflow: hidden;" *ngIf="Periods != null;">
    <div class="MainTitleBarIconContainer">
      <i class="material-icons">date_range</i>
    </div>
  
    <div class="FifteenPercentContainer">
      <mat-form-field class="PurchaseContractProductsColDropDown" appearance="outline">
        <mat-label>{{ 'PurchaseContracts.ChoosePeriod' | translate }}</mat-label>
        <mat-select name="Administration" [(ngModel)]="Filter.Period">
          <mat-option *ngFor="let a of this.Periods;" [value]="a" (click)="AddActiveFilter(a.Name, 'Period'); GetPurchaseContractsFiltered();">
            {{a.Name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  
    <div class="MainTitleBarIconContainer">
      <i class="material-icons">date_range</i>
    </div>
  
    <div class="FifteenPercentContainer">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'PurchaseContracts.FromDate' | translate }}</mat-label>
        <input matInput [matDatepicker]="dp" [formControl]="FromDate" [(ngModel)]="Filter.FromDate" (dateChange)="ClearPeriod()">
        <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
        <mat-datepicker #dp></mat-datepicker>
      </mat-form-field>
    </div>
  
    <div class="MainTitleBarIconContainer">
      <i class="material-icons">date_range</i>
    </div>
  
    <div class="FifteenPercentContainer">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'PurchaseContracts.ToDate' | translate }}</mat-label>
        <input matInput [matDatepicker]="dp1" [formControl]="ToDate" [(ngModel)]="Filter.ToDate" (click)="DisablePeriod();" (dateChange)="ClearPeriod()">
        <mat-datepicker-toggle matSuffix [for]="dp1"></mat-datepicker-toggle>
        <mat-datepicker #dp1></mat-datepicker>
      </mat-form-field>
    </div>
  
    <div class="FifteenPercentContainer" style="margin-top: -4px;">
        <button mat-mini-fab aria-label="Example icon button with a home icon" color="primary" (click)="GetPurchaseContractsFiltered();">
          <mat-icon>filter_alt</mat-icon>
        </button>
    </div>
  
  </div>
  
  <div class="MainTitleBar" style="overflow: unset;" *ngIf="Periods != null;">
      <div class="FilterButton noselect" (click)="this.showFilter = !this.showFilter;">
          <i class="material-icons">filter_alt</i>
          <span>Filter</span>
      </div>
  
      <div class="ActiveFiltersContainer">
        <div class="ActiveFilter" *ngFor="let a of this.activeFilters;" (click)="RemoveActiveFilter(a.ID, a.Type);">
          {{a.Name}}
          <i class="material-icons">close</i>
        </div>
      </div>
  
      <div class="FilterContainer animated fadeIn" *ngIf="showFilter">
          <div class="FilterCloseContainer" (click)="this.showFilter = false;">
              <i class="material-icons">close</i>
          </div>
  
          <div class="FilterContainerBody">
  
              <div class="PopUpBodyRow">
                
              </div>
  
              <div class="PopUpBodyOneThirddContainer">
                  <mat-form-field class="PurchaseContractProductsColDropDown" appearance="outline">
                      <mat-label>{{ 'PurchaseContracts.Administration' | translate }}</mat-label>
                      <mat-select name="Administration" [(ngModel)]="Filter.Administration">
                        <mat-option *ngFor="let a of this.Administrations;" [value]="a" (click)="AddActiveFilter(a.Name, 'Administration');">
                          {{a.Name}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
              </div>
              
              <div class="PopUpBodyOneThirddContainer">
              <mat-form-field class="PurchaseContractProductsColDropDown" appearance="outline">
                <mat-label>{{ 'PurchaseContracts.Series' | translate }}</mat-label>
                 <mat-select name="Series" [(ngModel)]="Filter.AccountingSeries">
                  <mat-option *ngFor="let a of this.AccountingSeries;" [value]="a" (click)="AddActiveFilter(a.Series, 'Series');">
                     {{a.Series}}
                   </mat-option>
                 </mat-select>
                </mat-form-field>
              </div>
               
              <div class="PopUpBodyOneThirddContainer">
                  <mat-form-field class="PurchaseContractProductsColDropDown" appearance="outline">
                      <mat-label>Doc.Status</mat-label>
                      <mat-select name="Series" [(ngModel)]="Filter.DocumentStatus">
                        <mat-option *ngFor="let d of this.DocumentStatuses;" [value]="d" (click)="AddActiveFilter(d.Name, 'DocStatus');">
                          {{d.Name}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
              </div>
              
              <div class="PopUpBodyTwoThirdsContainer">
                  <mat-form-field appearance="outline" class="PurchaseContractProductsColDropDown">
                      <mat-label>{{ 'SearchProductInvoicesFilter' | translate }}</mat-label>
                      <input matInput placeholder="{{ 'SearchProductInvoicesFilter' | translate }}" autocomplete="off" [(ngModel)]="Filter.Product" (change)="AddActiveFilter('PN: ' + Filter.Product, 'Product');">
                    </mat-form-field>
              </div>
  
              <div class="PopUpBodyTwoThirdsContainer">
                  <mat-form-field appearance="outline" style="width: 100%;padding: 0;" (click)="InitializePartnersOnClick(this.searchTerm, this.countryID, true);">
                      <mat-label>{{ 'PurchaseContracts.SearchSupplier' | translate }}*</mat-label>
                      <input matInput placeholder="Name/VAT" autocomplete="off" [(ngModel)]="this.searchTerm" (ngModelChange)="this.searchPartnerUpdate.next($event)" (keydown.enter)="this.partner = Partners[0];resultsLength = 0;this.searchTerm = Partners[0].Name;this.Filter.Partner = Partners[0];AddActiveFilter(Partners[0].Name, 'Partner');GetPurchaseContractsFiltered();">
                      <mat-icon matSuffix (click)="GetPartnersFiltered(this.searchTerm, this.countryID, true);" style="cursor: pointer;" *ngIf="this.partner == null;">search</mat-icon>
                      <i class="material-icons searchCloseButton" *ngIf="this.searchTerm" (click)="this.searchTerm=''; this.Partners.length = 0;resultsLength = 0; this.partner = null; this.Filter.Partner = null;">close</i>
                    </mat-form-field>
  
                    <div class="PartnerSearchResultsContainer" *ngIf="resultsLength > 0;">
                      <div class="PartnerSearchResult" *ngFor="let p of Partners" (click)="this.partner = p;resultsLength = 0;this.searchTerm=p.Name;this.Filter.Partner = p;AddActiveFilter(p.Name, 'Partner');">
                          <p class="SearchResultTitle DottedRow">{{p.Name}} <span style="font-weight: bold;" *ngIf="p.VAT?.length;">{{p.VAT}}</span></p>
                      </div>
                    </div>
              </div>
            
          </div>
          
          <div class="FilterCommands">
              <button mat-raised-button color="primary" class="FilterButtonAction" (click)="GetPurchaseContractsFiltered();">{{ 'PurchaseContracts.FilterButton' | translate }}</button>
          </div>
      </div>
  
      <div class="TotalDocCountContainer">
        <span style="float: right;">{{this.PurchaseContracts.length}} {{'OfWord' | translate}} {{this.Filter.Pager.TotalCount}} {{'PurchaseContractsWord' | translate}} ({{'Page' | translate}}: {{this.Filter.Pager.PageIndex}} {{'OfWord' | translate}} {{this.Filter.Pager.Pages}})</span>
        <div class="PageSizeContainer">
          <mat-form-field appearance="outline" class="PageSizeTextBox">
            <mat-label>{{ 'PageSize' | translate }}*</mat-label>
            <input matInput autocomplete="off" [(ngModel)]="Filter.Pager.PageSize" (change)="GetPurchaseContractsFiltered(1);">
          </mat-form-field>
        </div>
      </div>
  
      <div class="TotalDocCountContainer">
        <div class="TopPagingButton unSelectable" *ngIf="this.Filter.Pager.PageIndex != 1;" (click)="GetPurchaseContractsFiltered(this.Filter.Pager.PageIndex - 1);">
          <i class="material-icons">chevron_left</i>
        </div>
        <div class="TopPagingButton unSelectable" *ngIf="this.Filter.Pager.PageIndex == 1;" style="background: #eee;columns: #aaa;cursor: not-allowed;">
          <i class="material-icons">chevron_left</i>
        </div>
  
        <div class="TopPagingButton unSelectable" *ngIf="this.Filter.Pager.PageIndex != this.Filter.Pager.Pages;" (click)="GetPurchaseContractsFiltered(this.Filter.Pager.PageIndex + 1);">
          <i class="material-icons">chevron_right</i>
        </div>
        <div class="TopPagingButton unSelectable" *ngIf="this.Filter.Pager.PageIndex == this.Filter.Pager.Pages;" style="background: #eee;columns: #aaa;cursor: not-allowed;">
          <i class="material-icons">chevron_right</i>
        </div>
      </div>
  </div>
  
  <div class="MainBody">
  
      <div class="PurchaseContractProductsContainer">
        
          <div class="PurchaseContractProductsHeadder PurchaseContractProductsRow" style="border: none;">
              <div class="PurchaseContractProductsCol" style="width: 10%;">
                  {{ 'PurchaseContracts.Table.Nr' | translate }}
              </div>
              <div class="PurchaseContractProductsCol" style="width: 20%;">
                {{ 'Supplier' | translate }}
              </div>
              <div class="PurchaseContractProductsCol" style="width: 10%;text-align: left;padding-left: 1%;">
                {{ 'DocType' | translate }}
              </div>
              <div class="PurchaseContractProductsCol" style="width: 10%;">
                {{ 'StockEntryDate' | translate }}
              </div>
              <div class="PurchaseContractProductsCol" style="width: 10%;">
                {{ 'SubTotal' | translate }} <span *ngIf="Filter.ExchangeToTargetCurrency">({{currency.Name}})</span>
              </div>
              <div class="PurchaseContractProductsCol" style="width: 10%;">
                {{ 'VATTotal' | translate }} <span *ngIf="Filter.ExchangeToTargetCurrency">({{currency.Name}})</span>
              </div>
              <div class="PurchaseContractProductsCol" style="width: 10%;">
                  Total <span *ngIf="Filter.ExchangeToTargetCurrency">({{currency.Name}})</span>
              </div>
              <div class="PurchaseContractProductsCol" style="width: 10%;">
                {{ 'Status' | translate }}
              </div>
              <div class="PurchaseContractProductsCol" style="width: 10%;">
                {{ 'Actions' | translate }}
              </div>
          </div>
  
          <div class="PurchaseContractProductsRow TotalRow" *ngIf="loading">
              <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
          </div>
          <div *ngIf="!loading">
              <div [ngClass]="{'deactivatedPurchaseContract': r.DocumentStatus.ID == -1}" class="PurchaseContractProductsRow PurchaseContractProductsRowHover" *ngFor="let r of this.PurchaseContracts; let i=index;" (dblclick)="ViewPurchaseContract(r);">
              
                  <div class="PurchaseContractProductsCol" style="width: 10%;">
                      <p class="PurchaseContractTitleP">
                        <span (click)="VizualizeDocument(r);" class="PurchaseContractTitleSpan">{{r.AccountingNumber.DisplayValue}}</span>
                      </p>
                      <p *ngIf="r.IsStorno && loadingPCID != r.ID;" class="stornoRow">storno</p>
                      <mat-progress-bar mode="buffer" *ngIf="loadingDocumentInformation && loadingPCID == r.ID;" class="loadingDocumentInformation"></mat-progress-bar>
                  </div>
                  <div class="PurchaseContractProductsCol" style="width: 20%;">
                      <p>{{r.Supplier.Name}}</p>
                  </div>
                  <div class="PurchaseContractProductsCol" style="width: 10%;text-align: left;padding-left: 1%;">
                      <p>{{r.DocType.Meaning}}</p>
                  </div>
                  <div class="PurchaseContractProductsCol" style="width: 10%;">
                      {{r.EventRegisterUI}}
                  </div>
                  <div class="PurchaseContractProductsCol" style="width: 10%;">
                      <p>{{r.Total.UITotalQtyPriceNOVAT.Integer}} <span class="DecimalsSpan">{{r.Total.UITotalQtyPriceNOVAT.Decimals}}</span></p>
                  </div>
                  <div class="PurchaseContractProductsCol" style="width: 10%;">
                      <p>{{r.Total.UITotalVAT.Integer}} <span class="DecimalsSpan">{{r.Total.UITotalVAT.Decimals}}</span></p>
                  </div>
                  <div class="PurchaseContractProductsCol" style="width: 10%;">
                      <p>{{r.Total.UITotalQtyPriceVAT.Integer}} <span class="DecimalsSpan">{{r.Total.UITotalQtyPriceVAT.Decimals}}</span> <span class="PurchaseContractIndividualCurrencyRow" *ngIf="Filter.ExchangeToTargetCurrency == false;">{{r.Currency.Name}}</span></p>
                  </div>
                  <div class="PurchaseContractProductsCol" style="width: 10%;">
                    <p>
                      <span [ngClass]="{'CancelledStatus': r.DocumentStatus.ID == -1, 'CollectedStatus': r.DocumentStatus.ID == 1,'PartiallyCollected': r.DocumentStatus.ID == 2,'SurplusCollected': r.DocumentStatus.ID == 3, 'CreatedStatus': r.DocumentStatus.ID == 4, 'Overdue': r.DocumentStatus.ID == 5}">{{r.DocumentStatus.Name}}</span>
                  </p>
                  </div>
                  <div class="PurchaseContractProductsCol" style="width: 10%;">
                      <i class="material-icons actionsArrow" [matMenuTriggerFor]="menu">keyboard_arrow_down</i>
                         <mat-menu #menu="matMenu">
                          <button mat-menu-item class="PurchaseContractMenuButton" (click)="VizualizeDocument(r);">
                              <i class="material-icons">image_search</i>
                              <span>{{ 'PurchaseContracts.Table.ButtonMenu.Visualize' | translate }}</span>
                          </button>
                          <button mat-menu-item (click)="ViewPurchaseContract(r);" class="PurchaseContractMenuButton" *ngIf="r.DocumentStatus.ID != -1;">
                              <i class="material-icons">mode_edit</i>
                              <span>{{ 'PurchaseContracts.Table.ButtonMenu.modify' | translate }}</span>
                          </button>
                          <button mat-menu-item class="PurchaseContractMenuButton" (click)="GenerateStorno(r);" *ngIf="r.DocumentStatus.ID != -1 && r.IsStorno != true;">
                              <i class="material-icons">settings_backup_restore</i>
                              <span>{{ 'PurchaseContracts.Table.ButtonMenu.stornate' | translate }}</span>
                          </button>
                          <button mat-menu-item class="PurchaseContractMenuButton" *ngIf="r.DocumentStatus.ID == 1;" (click)="ShowDeactivateDocumentQuestion = true; CurrentPurchaseContract = r;">
                              <i class="material-icons">close</i>
                              <span>{{ 'PurchaseContracts.Table.ButtonMenu.cancelDoc' | translate }}</span>
                          </button>
                          <button mat-menu-item class="PurchaseContractMenuButton" *ngIf="r.DocumentStatus.ID == -1;" (click)="ShowReactivateDocumentQuestion = true; CurrentPurchaseContract = r;">
                              <i class="material-icons">verified</i>
                              <span>{{ 'PurchaseContracts.Table.ButtonMenu.reactivateDoc' | translate }}</span>
                          </button>
                          <button mat-menu-item class="PurchaseContractMenuButton" (click)="ShowDeletePCQuestion = true; this.CurrentPurchaseContract = r;">
                              <i class="material-icons">delete_forever</i>
                              <span>{{ 'PurchaseContracts.Table.ButtonMenu.delete' | translate }}</span>
                          </button>
                          <button mat-menu-item class="PurchaseContractMenuButton" (click)="initializePartnerFormFromObject(r.Supplier);">
                              <i class="material-icons">person_search</i>
                              <span>{{ 'PurchaseContracts.Table.ButtonMenu.viewSupplier' | translate }}</span>
                          </button>
                          <button mat-menu-item class="PurchaseContractMenuButton" *ngIf="r.DocumentStatus.ID == 1;" (click)="GenerateReceptionFromPurchaseContract(r);">
                            <i class="material-icons">view_comfortable</i>
                            <span>{{ 'GenerateReception' | translate }}</span>
                        </button>
                         </mat-menu>
                  </div>
        </div>
          </div>
  
          <div *ngIf="!loading && PurchaseContracts.length > 0;">
            <div class="PurchaseContractProductsRow PurchaseContractProductsRowHover TotalRow" *ngFor="let Total of this.Totals; let i=index;">
              <div class="PurchaseContractProductsCol" style="width: 30%;text-align: left;padding-left: 1%;">
                <mat-slide-toggle (change)="GetPurchaseContractsFiltered();" *ngIf="i == 0;" [(ngModel)]="Filter.ExchangeToTargetCurrency">{{'DisplaySingleCurrency' | translate}}</mat-slide-toggle>
              </div>
              <div class="PurchaseContractProductsCol" style="width: 10%;text-align: left;padding-left: 1%;">
              </div>
              <div class="PurchaseContractProductsCol totalCol" style="width: 10%;">
                  Total:
              </div>
              <div class="PurchaseContractProductsCol totalCol" style="width: 10%;">
                  <p>{{Total.UITotalQtyPriceNOVAT.Integer}} <span class="DecimalsSpan">{{Total.UITotalQtyPriceNOVAT.Decimals}}</span></p>
              </div>
              <div class="PurchaseContractProductsCol totalCol" style="width: 10%;">
                  <p>{{Total.UITotalVAT.Integer}} <span class="DecimalsSpan">{{Total.UITotalVAT.Decimals}}</span></p>
              </div>
              <div class="PurchaseContractProductsCol totalCol" style="width: 10%;">
                  <p>{{Total.UITotalQtyPriceVAT.Integer}} <span class="DecimalsSpan">{{Total.UITotalQtyPriceVAT.Decimals}}</span></p>
              </div>
              <div class="PurchaseContractProductsCol totalCol" style="width: 10%;">
                  {{Total.Currency.Name}}
              </div>
              <div class="PurchaseContractProductsCol" style="width: 10%;">
                  
              </div>
          </div>
          </div>
  
      <div class="PurchaseContractProductsRow PurchaseContractProductsRowHover TotalRow" *ngIf="!loading && PurchaseContracts.length > 0;">
        <div class="PurchaseContractProductsCol" style="width: 10%;">
  
        </div>
        <div class="PurchaseContractProductsCol" style="width: 20%;">
        </div>
        <div class="PurchaseContractProductsCol" style="width: 10%;text-align: left;padding-left: 1%;">
        </div>
        <div class="PurchaseContractProductsCol totalCol" style="width: 10%;">
          <button mat-raised-button *ngIf="this.Filter.Pager.PageIndex != 1;" (click)="GetPurchaseContractsFiltered(this.Filter.Pager.PageIndex - 1);">
            <i class="material-icons">chevron_left</i>
          </button>
  
          <button mat-raised-button *ngIf="this.Filter.Pager.PageIndex == 1;" style="background: #eee;cursor: not-allowed;">
            <i class="material-icons">chevron_left</i>
          </button>
        </div>
        <div class="PurchaseContractProductsCol totalCol" style="width: 10%;">
          {{this.Filter.Pager.PageIndex}} / {{this.Filter.Pager.Pages}}
        </div>
        <div class="PurchaseContractProductsCol totalCol" style="width: 10%;">
          <button mat-raised-button *ngIf="this.Filter.Pager.PageIndex != this.Filter.Pager.Pages;" (click)="GetPurchaseContractsFiltered(this.Filter.Pager.PageIndex + 1);">
            <i class="material-icons">chevron_right</i>
          </button>
  
          <button mat-raised-button *ngIf="this.Filter.Pager.PageIndex == this.Filter.Pager.Pages;" style="background: #eee;cursor: not-allowed;">
            <i class="material-icons">chevron_right</i>
          </button>
        </div>
        <div class="PurchaseContractProductsCol totalCol" style="width: 10%;">
            
        </div>
        <div class="PurchaseContractProductsCol totalCol" style="width: 10%;">
            
        </div>
        <div class="PurchaseContractProductsCol" style="width: 10%;">
            
        </div>
    </div>
  
      </div>
  
  </div>
  </div>
  